import { render, staticRenderFns } from "./NeutralIcon.vue?vue&type=template&id=5c98f3a8&functional=true"
import script from "./NeutralIcon.vue?vue&type=script&lang=js"
export * from "./NeutralIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports